import { render, staticRenderFns } from "./VolunteerChange.vue?vue&type=template&id=04ec4745"
import script from "./VolunteerChange.vue?vue&type=script&lang=js"
export * from "./VolunteerChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports